import { render, staticRenderFns } from "./fengkong.vue?vue&type=template&id=eff48c48&scoped=true&"
import script from "./fengkong.vue?vue&type=script&lang=js&"
export * from "./fengkong.vue?vue&type=script&lang=js&"
import style0 from "./fengkong.vue?vue&type=style&index=0&id=eff48c48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff48c48",
  null
  
)

export default component.exports